var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ci-usp-component position-relative" }, [
    _c("div", { staticClass: "usp-content px-3 py-5" }, [
      _c("div", { staticClass: "flex-row position-relative mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2" },
          [
            _c(_vm.headingType, {
              tag: "component",
              staticClass: "h2 text-center",
              domProps: {
                textContent: _vm._s(
                  _vm.$t("ui.components.base.capinside_usp.title")
                ),
              },
            }),
            _c("div", {
              staticClass: "text-center",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("ui.components.base.capinside_usp.text")
                ),
              },
            }),
            _c("div", {
              staticClass: "alternates text-center",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("ui.components.base.capinside_usp.alternates")
                ),
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap justify-content-between py-4" },
        _vm._l(_vm.uniqueSellingPoints, function (usp, index) {
          return _c("div", { key: index, staticClass: "col-12 col-md-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row flex-md-column align-items-center",
              },
              [
                _c("div", { staticClass: "flex-shrink-1" }, [
                  _c("div", { staticClass: "icon-circle mb-3 mr-3 mr-md-0" }, [
                    _c("div", {
                      staticClass: "text-primary-700 mdi",
                      class: usp.icon,
                    }),
                  ]),
                ]),
                _c("p", {
                  staticClass: "text-md-center",
                  domProps: { innerHTML: _vm._s(_vm.$t(usp.text)) },
                }),
              ]
            ),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "flex-row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-4 offset-md-4" },
          [
            _c("ci-button", {
              staticClass: "w-100",
              attrs: {
                label: _vm.$t("ui.components.base.login_form.register_full"),
                variant: "filled-primary",
                to: {
                  path: "/users/sign_up",
                  query: { onboarding_type: "value-banner" },
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }